import Footer from "components/ui/Footer";
import { useState, useEffect } from "react";
import { getSubscriptionPlans } from "services/subscriptionPlanService";
import Pricing from "./components/Pricing";

const SubscriptionPlans = () => {
    

    return (
        <div className="min-h-screen flex flex-col justify-between">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div>
                    <h1 className="text-3xl font-bold mt-10">Subscription Plans</h1>
                    <p>Choose the plan that fits your needs.</p>
                </div>
            </div>

            {/* Pricing / CTA */}
            <Pricing/>

            <Footer />
            
        </div>
        
    );
};

export default SubscriptionPlans;
